import { getHttpUrl } from './httpUrl';

/** Определяет отображение файла по MIME-типу или расширению веб-адреса */
export const getFileMediaKind = (
    value: string,
    mimeType?: string | null,
): 'image' | 'video' | 'audio' | 'file' => {
    const url = getHttpUrl(value);

    if (!url) return 'file';

    const mime = mimeType?.split(';')[0].trim().toLowerCase();

    if (mime?.startsWith('image/')) return 'image';
    if (mime?.startsWith('video/')) return 'video';
    if (mime?.startsWith('audio/')) return 'audio';
    if (mime && mime !== 'application/octet-stream') return 'file';

    try {
        const extension = decodeURIComponent(new URL(url).pathname).split('.').pop()?.toLowerCase() ?? '';

        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'avif'].includes(extension)) return 'image';
        if (['mp4', 'webm', 'mov', 'm4v', 'mpeg', 'mpg', '3gp'].includes(extension)) return 'video';
        if (['mp3', 'wav', 'ogg', 'aac', 'm4a', 'opus', 'flac', 'weba'].includes(extension)) return 'audio';
    } catch {
        // Нераспознаваемый адрес остаётся обычным файлом без автоматического просмотра
    }

    return 'file';
};
